export const normalizeHref = (href: string): string =>
  href.startsWith('http') || href.startsWith('/') || href.includes(':') ? href : `/${href}`
